import { getFilmById } from '../../browsing/selectors/films/get-film-by-id';
import { hasValidValuesForFilter } from './has-valid-values-for-filter';
export const filterShowtimes = (filter, allShowtimes) => {
    return allShowtimes.filter(showtime => {
        const film = getFilmById(showtime.filmId);
        return (film &&
            hasValidValuesForFilter(filter.sections.genre, film.genreIds) &&
            hasValidValuesForFilter(filter.sections.attribute, showtime.attributeIds) &&
            hasValidValuesForFilter(filter.sections.event, showtime.eventId ? [showtime.eventId] : []));
    });
};
